import state from '@/store/todo/moduleTodoState.js'
import mutations from '@/store/todo/moduleTodoMutations.js'
import actions from '@/store/todo/moduleTodoActions.js'
import getters from '@/store/todo/moduleTodoGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
